module.exports = __webpack_public_path__ + "img/usecase-content.53f57c60.png";